exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2wPZcB4gH3QRZ1z4qiWMIT{display:inline-block;height:1.5em;line-height:1.5em;border-radius:1.5em;background:currentColor;padding:0 0.5em;text-align:center;margin:0 4px}._3aQNdU8k_dIHDqYtqgUMxe{color:#fff;font-weight:bold}\n", ""]);

// Exports
exports.locals = {
	"Gleam": "_2wPZcB4gH3QRZ1z4qiWMIT",
	"content": "_3aQNdU8k_dIHDqYtqgUMxe"
};